module.exports = __webpack_public_path__ + "static/media/cases_web_keslon_04b.259d9c0a.jpg";